/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {

    export class EgiftDynamicMinValue implements angular.IDirective {
        require = 'ngModel';
        restrict = 'A';
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: any) => {
            if (angular.isUndefined(attrs.dynamicMinValue)) return;

            scope.$watch(attrs.ngModel, (newVal, oldVal) => {
                if (newVal === oldVal) return;

                if (ngModel.$modelValue && ngModel.$modelValue.length == 0 ||
                    (+ngModel.$modelValue < +attrs.dynamicMinValue && !(attrs.excludeMinValue && +attrs.excludeMinValue === ngModel.$modelValue))) {

                    ngModel.$setViewValue(+attrs.dynamicMinValue);
                }
            });

        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EgiftDynamicMinValue();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('egiftDynamicMinValue', EgiftDynamicMinValue.factory());
}
